<!--赖传峰-->
<!--2022/4/13-->
<template>
  <div
    :class="props.viewType"
    class="operation"
  >
    <div
      v-if="props.mobileSelectMode"
      class="checkbox-wrap"
    >
      <span
        :class="checked && 'checked'"
        class="pp-checkbox"
      />
    </div>
    <a
      v-else
      class="pp-link-button"
      @dblclick.prevent.stop="handleOperation"
      @contextmenu.prevent.stop="handleOperation"
      @click.stop="handleOperation"
    >
      <EllipsisIcon
        color="#a8b2bd"
        style="transform: rotate(90deg)"
      />
    </a>
  </div>
</template>

<script lang="ts" setup>
import { computed } from '#imports'
import EllipsisIcon from '@/components/icons/EllipsisIcon.vue'
import { useShare } from '@/store/share'
import { ViewType } from '~/types/enum'

const emit = defineEmits<{ (e: 'clickShowContextMenu', target: Element): void }>()

const shareStore = useShare()

const handleOperation = (e: MouseEvent) => emit('clickShowContextMenu', e.target as Element)

const props = defineProps<{ file: PPFile; viewType: ViewType; mobileSelectMode: boolean }>()
const checked = computed(() => shareStore.selectedIds.includes(props.file.id))
</script>

<style lang="less" scoped>
@import '@/assets/styles/util';

.operation {
  display: flex;
  align-items: center;

  .checkbox-wrap {
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &.grid {
    padding: 0;
    position: absolute;
    right: 0;
    bottom: 0;
    justify-content: center;

    .pp-link-button {
      background: #fff;
      border-radius: 4px;
      margin-right: 8px;
      margin-bottom: 8px;
      min-width: 24px;
      height: 24px;
    }
  }

  &.list {
    height: 100%;
    justify-content: flex-end;
  }

  &.single {
    display: none;
  }
}
</style>
